
<div class="header1-header1"  [ngClass]="{'fixed-menu': isSticky}">
  <div class="header1-frame120">
    <img src="/assets/external/mobile/vectori3437-bh6j.svg" class="header1-vector" (click)="goHome()"/>
    <img src="/assets/external/LogoFull.svg" alt="Blue Assist" class="header1-logo-full" (click)="goHome()"/> 
    <div class="header1-frame108 d-none">
      <div class="header1-icon"></div>
      <span class="header1-text Mob,H1,Bold,14">
        <span>
          Paso 2 de 5
        </span>
      </span>
      <div class="header1-icon1"></div>
    </div>
    <div class="header-right-section">
    <button type="submit" (click)="goQuote()" class="btn btn-primary continue-btn-steps" *ngIf="showQuoteButton">Cotizar Seguro</button>
    <input type="checkbox" id="checkboxBarMenu" style="display:none">
    <label class="header1-menu" for="checkboxBarMenu" id="menuHambur" (click)="menuChange()">
      <span class="bar top"></span>
      <span class="bar middle"></span>
      <span class="bar bottom"></span>
    </label>
  </div>
    <!-- <div class="header1-menu">
      <img
        src="/assets/external/mobile/rectangle497i3437-poer-200h.png"
        class="header1-rectangle497"
      />
      <img
        src="/assets/external/mobile/rectangle498i3437-w7ao-200h.png"
        class="header1-rectangle498"
      />
      <img
        src="/assets/external/mobile/rectangle499i3437-uzs7-200h.png"
        class="header1-rectangle499"
      />
    </div> -->
  </div>
</div>

